import React from "react"
import {
  Select as MUISelect,
  SelectProps as MUISelectProps,
} from "@mui/material"

export type SelectProps =
  | ({ new?: false } & MUISelectProps)
  | ({ new: true } & unknown)

export const Select = React.forwardRef<HTMLDivElement, SelectProps>(
  (props, ref) => (props.new ? null : <MUISelect {...props} ref={ref} />),
)

Select.displayName = "Select"

export default Select
